import { Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip'

import { type FloatingTriggerType } from '@/defs/floating'

import { FloatingArrow } from '../../common/FloatingArrow/FloatingArrow'
import { getFloatingContentProps } from '../../common/getFloatingContentProps'
import { FloatingBox } from '../../FloatingBox/FloatingBox'

export const FloatingTooltipDesktop = ({ children, ignoreScopes, placement, ...rest }: FloatingTriggerType) => (
  <Provider delayDuration={100}>
    <Root>
      <Trigger asChild>{children}</Trigger>
      <Portal>
        <Content {...getFloatingContentProps({ ignoreScopes, placement })}>
          <FloatingArrow type='tooltip' />
          <FloatingBox {...rest} />
        </Content>
      </Portal>
    </Root>
  </Provider>
)
